import PropTypes from 'prop-types';
import React from 'react';
import { ToggleButton } from 'react-bootstrap';

const ToggleButtonRadioOption = ({ value, children, ...props }) => {
  return (
    <ToggleButton value={value.toString()} variant="secondary" {...props}>
      {children}
    </ToggleButton>
  );
};

ToggleButtonRadioOption.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  children: PropTypes.node,
};

export default ToggleButtonRadioOption;
